import { useCallback } from 'react';
import noimage from '../images/no-image.jpg';

export const useValidateImage = (defaultAvatar) => useCallback((e) => {
	e.target.src = defaultAvatar || noimage;
}, [defaultAvatar]);
